/** One SMYM account for every paid event. Not stored per event. */
export const BANK_DETAILS = {
  name: 'SHREE MAHESWARI YUVA MANDAL',
  bankName: 'Karur Vysya Bank',
  branch: 'Godown St Branch, Chennai - 600 001',
  accountNumber: '1755115000000465',
  ifscCode: 'KVBL0001755',
} as const;

export const PAYMENT_HELPLINE = {
  digits10: '8610447053',
  display: '86104 47053',
} as const;

/** Event note under the bank card. Hide a note that only repeats the shared account. */
export function extraPaymentNote(instructions: string | null | undefined): string {
  const text = instructions?.trim() ?? '';
  if (!text || text.includes(BANK_DETAILS.accountNumber)) return '';
  return text;
}
